import React, { Fragment, FunctionComponent } from 'react';
import ShopLayout from '@views/components/shop/ShopLayout';
import Sidebar from './sub-modules/sidebar';
import CategoryList from './sub-modules/category-list/placeholder';
import ProductList from './sub-modules/product-list/placeholder';

export const Placeholder: FunctionComponent<any> = () => (
  // <ShopLayout>
  //   <ShopLayout.Sidebar as="nav" className="d-none d-lg-block">
  //     <Sidebar />
  //   </ShopLayout.Sidebar>
  //   <ShopLayout.Content>
  <Fragment>
    <CategoryList />
    <ProductList />
  </Fragment>
  //   </ShopLayout.Content>
  // </ShopLayout>
);

export default Placeholder;
